import React from 'react';
import PrimaryHeading from "../../components/PrimaryHeading/PrimaryHeading";
import HeadingGradient from "../../components/HeadingGradient/HeadingGradient";
import Tile from "../../components/Tile/Tile";
import SecondaryHeading from "../../components/SecondaryHeading/SecondaryHeading";
import MegaDrivers from "../../components/MegaDrivers/MegaDrivers";

function SectionDisruption({ cravingsData }) {
    return (
        <div className="details-chart">
            <PrimaryHeading>
                <HeadingGradient>DISRUPTIONS TO THE SEQUENCE</HeadingGradient>
                <span>sometimes cravings can derail<br/> consumers original plans</span>
            </PrimaryHeading>
            <Tile>
                <SecondaryHeading>
                    Cravings
                </SecondaryHeading>
                <div className="cravings">
                    <div className="cravings__top">
                        <div className="cravings__text">
                            Disrupted by a craving
                        </div>
                        <div className="cravings__percents">
                            <div
                                className="cravings__disrupted"
                                style={{ width: `${cravingsData.disrupted}%` }}
                            >
                                {cravingsData.disrupted}%
                            </div>
                            <div
                                className="cravings__not-disrupted"
                                style={{ width: `${cravingsData.notDisputed}%` }}
                            >
                                {cravingsData.notDisputed}%
                            </div>
                        </div>
                        <div className="cravings__text">Not disrupted by a
                            craving
                        </div>
                    </div>
                    <MegaDrivers data={cravingsData.items}/>
                </div>
            </Tile>
        </div>
    );
}

export default SectionDisruption;